import { Component } from '@angular/core';

interface StatCard {
  label: string;
  value: string;
  trend: number;
  trendLabel: string;
  variant: string;
}

interface MonthBar {
  month: string;
  value: number;
}

interface CategoryItem {
  label: string;
  count: number;
  percent: number;
  color: string;
}

interface ActivityRow {
  id: number;
  initials: string;
  user: string;
  action: string;
  time: string;
  status: 'completed' | 'pending' | 'failed';
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  today = new Date();

  stats: StatCard[] = [
    { label: 'Total Users',      value: '1,248', trend:  12.5, trendLabel: 'vs last month', variant: 'primary' },
    { label: 'Revenue',          value: '$48.2K', trend:  8.3,  trendLabel: 'vs last month', variant: 'success' },
    { label: 'Open Reports',     value: '186',    trend: -3.2,  trendLabel: 'vs last month', variant: 'warning' },
    { label: 'Active Sessions',  value: '93',     trend:  5.1,  trendLabel: 'right now',     variant: 'info'    }
  ];

  monthlyData: MonthBar[] = [
    { month: 'Jan', value: 55 }, { month: 'Feb', value: 72 },
    { month: 'Mar', value: 48 }, { month: 'Apr', value: 88 },
    { month: 'May', value: 65 }, { month: 'Jun', value: 91 },
    { month: 'Jul', value: 60 }, { month: 'Aug', value: 78 },
    { month: 'Sep', value: 50 }, { month: 'Oct', value: 84 },
    { month: 'Nov', value: 70 }, { month: 'Dec', value: 95 }
  ];

  categories: CategoryItem[] = [
    { label: 'Documents',  count: 524, percent: 42, color: 'var(--color-primary)'       },
    { label: 'Reports',    count: 349, percent: 28, color: 'var(--color-primary-light)'  },
    { label: 'Users',      count: 224, percent: 18, color: 'var(--color-accent)'         },
    { label: 'Other',      count: 151, percent: 12, color: 'var(--color-accent-light)'   }
  ];

  recentActivity: ActivityRow[] = [
    { id: 1, initials: 'JS', user: 'John Smith',     action: 'Created report Q4 2025',    time: '2 mins ago',   status: 'completed' },
    { id: 2, initials: 'SJ', user: 'Sarah Johnson',  action: 'Updated user profile',       time: '15 mins ago',  status: 'completed' },
    { id: 3, initials: 'MD', user: 'Mike Davis',     action: 'Exported document bundle',   time: '1 hour ago',   status: 'pending'   },
    { id: 4, initials: 'EC', user: 'Emily Chen',     action: 'Scheduled system backup',    time: '3 hours ago',  status: 'failed'    },
    { id: 5, initials: 'RL', user: 'Robert Lee',     action: 'Generated invoice #1042',    time: '5 hours ago',  status: 'completed' },
    { id: 6, initials: 'AP', user: 'Anna Park',      action: 'Uploaded 3 documents',       time: '6 hours ago',  status: 'completed' },
    { id: 7, initials: 'TK', user: 'Tom Kim',        action: 'Password reset requested',   time: 'Yesterday',    status: 'pending'   }
  ];

  get maxBarValue(): number {
    return Math.max(...this.monthlyData.map(d => d.value));
  }

  barHeight(value: number): number {
    return Math.round((value / this.maxBarValue) * 100);
  }
}
